import { useLazyQuery } from "@apollo/client";
import { GET_3D_MODEL, GET_HOT_SPOTS } from "./HomeHotSpot.gql";
import { useEffect, useState } from "react";
import DEFAULT_OPERATIONS from "../../Pregrine/PinCode/PinCode.gql";
import { useAddToCartButton } from "../CartPage/useAddToCartButton";
import { useToasts } from "react-toast-notifications";

const useInspirationZone = () => {
  const [selectedItem, setSelectedItem] = useState("");
  const [openPinCodeModal, setOpenPinCodeModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { checkPinCodeQuery } = DEFAULT_OPERATIONS;
  const { addToast } = useToasts();

  const [getHotSpots, { data, loading, error }] = useLazyQuery(GET_HOT_SPOTS, {
    context: { fetchOptions: { method: "GET" } },
  });
  const [
    get3dModel,
    { data: modelData, loading: modelLoading, error: modelError },
  ] = useLazyQuery(GET_3D_MODEL, {
    context: { fetchOptions: { method: "GET" } },
  });

  let spotsData = [];

  useEffect(() => {
    if (window.innerWidth < 500) {
      getHotSpots({ variables: { type: "1" } });
    } else {
      getHotSpots({ variables: { type: "0" } });
    }
  }, [window.innerWidth]);

  if (data && data?.getHotspot && data?.getHotspot["product_data"]) {
    spotsData = data.getHotspot["product_data"].map((item) => {
      const position = item["hotspot_style"];
      const arr = position.split(";");
      const finalArr = arr.slice(0, arr.length - 1);
      let positionObject = {};
      finalArr.forEach((item) => {
        const [first, second] = item.split(":");
        positionObject[first.trim()] = second;
      });
      return { ...item, positionObject };
    });
  }

  const cartButtonProps = useAddToCartButton({
    item: selectedItem,
  });

  const { handleAddToCart } = cartButtonProps;
  const [checkPinCode] = useLazyQuery(checkPinCodeQuery, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.pin_code?.status === "1") {
        handleAddToCart();
      } else {
        addToast(
          "Delivery not available to this location. Please check for other options.",
          {
            appearance: "warning",
            autoDismiss: true,
            style: {
              backgroundColor: "#745600",
              color: "#fff",
            },
          }
        );
      }
    },
  });

  const handleCart = (sku) => {
    const pincode = localStorage.getItem("PinCode");
    if (pincode) {
      checkPinCode({
        variables: {
          pinCode: pincode,
          sku,
          state: Math.random(),
        },
      });
    } else {
      setOpenPinCodeModal(!openPinCodeModal);
    }
  };

  const pinCodeCheckFun = (availableFlag) => {
    if (availableFlag) {
      handleAddToCart();
      setOpenPinCodeModal(false);
    }
  };

  const handlePinCodeModal = () => {
    setOpenPinCodeModal(false);
  };

  return {
    data,
    loading,
    error,
    spotsData,
    setSelectedItem,
    handlePinCodeModal,
    handleCart,
    pinCodeCheckFun,
    openPinCodeModal,
    selectedItem,
    get3dModel,
    modelData,
    modelLoading,
    showModal,
    setShowModal,
  };
};

export default useInspirationZone;
